module.exports = __webpack_public_path__ + "bg-header-menu-2-uc2.jpg";